<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            Editar indicador propio
          </div>
        </q-card-section>
        <q-card-section class="container-auth q-pt-none q-col-gutter-y-sm">
          <slot name="body">
            <q-form ref="form">
              <div class="form-row">
                <!--Nombre indicador-->
                <div class="input-name">
                  <q-input
                    v-model="name"
                    type="text"
                    label="*Nombre"
                    outlined
                    :rules="[val => !!val || 'Campo obligatorio']"
                  >
                  </q-input>
                </div>
                <!--Tipo-->
                <div class="input-tipo">
                  <q-select
                    outlined
                    :options="optionsTipo"
                    option-value="id"
                    option-label="value"
                    v-model="optionsTipoSelected"
                    label="*Selecciona un tipo"
                    @input="changeTipoSelected"
                    :rules="[val => !!val || 'Campo obligatorio']"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="input-20">
                  <q-select
                    label="*Periodicidad"
                    class="input col-12"
                    outlined
                    :options="
                      optionsPeriodicidad ? optionsPeriodicidad : 'No hay datos'
                    "
                    option-value="id"
                    option-label="name"
                    v-model="optionPeriodicidadSelected"
                    ref="refPeriodicidad"
                    :disable="disableInputsByTipo()"
                    :rules="rulesByTipo"
                  >
                  </q-select>
                </div>
                <!--unidad de medidad-->
                <div class="input-20">
                    <q-input
                      v-model="unidadMedida"
                      type="text"
                      label="*Unidad de medida"
                      outlined
                      ref="refMedida"
                      :disable="disableInputsByTipo()"
                      :rules="rulesByTipo"
                    ></q-input>
                </div>
                <!--valor recomendado-->
                <div class="input-20">
                  <q-input
                    v-model="minimoRecomendado"
                    type="number"
                    label="Mínimo recomendado"
                    outlined
                    :disable="disableInputsByTipo()"
                  ></q-input>
                </div>
                <!--entidad recomendadora-->
                <div class="input-35">
                  <q-input
                      v-model="recomendadoPor"
                      type="text"
                      label="Entidad recomendadora"
                      outlined
                      :disable="disableInputsByTipo()"
                    ></q-input>
                </div>
              </div>
              <div class="form-row-bottom-space">
                 <!--como se calcula-->
                <div class="input-60">
                    <q-input
                      v-model="formula"
                      type="text"
                      label="Cómo se calcula"
                      outlined
                      :disable="true"
                    ></q-input>
                </div>
                <!--fuente-->
                <div class="input-40">
                  <q-input
                      v-model="fuente"
                      type="text"
                      label="Fuente"
                      outlined
                      :disable="true"
                    ></q-input>
                </div>
              </div>
              <div class="form-row-bottom-space">
                <!--que es-->
                  <div class="input-100">
                    <q-input
                      v-model="descripcion"
                      type="textarea"
                      label="Qué es"
                      outlined
                      :disable="true"
                    ></q-input>
                </div>
              </div>
                <!--beneficio-->
               <div class="form-row-bottom-space">
                  <div class="input-100">
                    <q-input
                      v-model="beneficio"
                      type="textarea"
                      label="Beneficio"
                      outlined
                      :disable="true"
                    ></q-input>
                  </div>
              </div>
              <div class="form-row-bottom-space">
                <!--aclaraciones-->
                <div class="input-100">
                  <q-input
                  v-model="aclaraciones"
                  type="textarea"
                  label="Aclaraciones"
                  outlined
                  :disable="true"
                ></q-input>
                </div>
              </div>
              <div class="row select">
                <!--ods-->
                <div class="col-1">
                  <q-img
                    class="Imagen"
                    :src="imgODSSelected"
                    :name="imgODSSelected"
                    style="border-radius: 0px !important"
                    width="50px"
                    height="50px"
                  />
                </div>
                <q-select
                  class="input col-11"
                  outlined
                  :options="arrayObjetivosODS"
                  option-value="id"
                  option-label="name"
                  v-model="objetivoODSSelected"
                />
              </div>
              <div class="row select">
                <!--estrategicos-->
                <div class="col-1">
                  <q-img
                    class="Imagen"
                    :src="imgEstrategicoSelected"
                    :name="imgEstrategicoSelected"
                    style="border-radius: 50%"
                    width="50px"
                    height="50px"
                  />
                </div>
                <q-select
                  class="input col-11"
                  outlined
                  :options="arrayObjetivosEstrategicos"
                  option-value="id"
                  option-label="name"
                  v-model="objetivoEstrategicoSelected"
                  :error="$v.objetivoEstrategicoSelected.$error"
                />
              </div>
              <div class="row select">
                <!--especificos-->
                <div class="col-1">
                </div>
                <q-select
                  class="input col-11"
                  outlined
                  :options="arrayObjetivosEspecificos"
                  option-value="id"
                  option-label="name"
                  v-model="objetivoEspecificoSelected"
                  :error="$v.objetivoEspecificoSelected.$error"
                />
              </div>
            </q-form>
          </slot>
        </q-card-section>

        <q-card-actions align="right" class="text-primary container-actions">
          <q-btn
            class="bSecondary"
            flat
            label="Cancelar"
            v-close-popup
            @click="cancel()"
          />
          <q-btn
            label="Guardar"
            class="bPrincipal"
            padding="xs lg"
            @click="save()"
            :disable="disableSave()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { QDialog, QForm, QImg } from 'quasar';
import Validation from '@/components/shared/mixins/Validation.js';
import { required } from 'vuelidate/lib/validators';
import Resources from '@/components/shared/mixins/Resources.js';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  mixins: [Validation, Resources, Loading],
  components: {
    QDialog,
    QForm,
    QImg
  },
  validations: {
    objetivoEspecificoSelected: { required },
    objetivoEstrategicoSelected: { required }
  },
  props: {
    value: {
      required: true
    },
    datosIndicador: {
      required: true
    }
  },
  computed: {
    rulesByTipo () {
      if (this.optionsTipoSelected) {
        return this.optionsTipoSelected.value === 'Cualitativo'
          ? [val => !val]
          : [val => !!val || 'Campo obligatorio'];
      } else {
        return [val => !!val || 'Campo obligatorio'];
      }
    }
  },
  data () {
    return {
      valueLocal: this.value,
      arrayObjetivosEstrategicos: [],
      objetivoEstrategicoSelected: {},
      imgEstrategicoSelected: '',
      arrayObjetivosODS: [],
      objetivoODSSelected: {},
      imgODSSelected: '',
      arrayObjetivosEspecificos: [],
      objetivoEspecificoSelected: {},
      tipoIndicator: null,
      name: '',
      periodicidad: '',
      unidadMedida: '',
      minimoRecomendado: '',
      recomendadoPor: '',
      fuente: '',
      formula: '',
      descripcion: '',
      beneficio: '',
      aclaraciones: '',
      labelRecomendado: 'Valor recomendado',
      optionsTipoSelected: null,
      optionsTipo: [
        { id: 1, value: 'Cualitativo' },
        { id: 2, value: 'Cuantitativo' }
      ],
      optionsPeriodicidad: [],
      optionPeriodicidadSelected: null
    };
  },
  async created () {
    await this.$store
      .dispatch(types.ACTION_GET_PERIODICIDAD)
      .then(response => {
        this.optionsPeriodicidad = response.data.periodicidades;
      });
    this.fillDetalle();
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    },
    objetivoEstrategicoSelected: {
      handler: function (val) {
        this.loading = true;
        if (!val) return;
        this.imgEstrategicoSelected = this.getImg(val.file);
        if (val.id !== null && val.id !== undefined) {
          this.fillSelectorObjetivosEspecificos();
        } else {
          this.arrayObjetivosEspecificos = [];
          this.arrayObjetivosEspecificos.push({ name: 'Seleccione un objetivo específico' });
          this.objetivoEspecificoSelected = this.arrayObjetivosEspecificos[0];
        }
      },
      deep: true
    },
    objetivoODSSelected: {
      handler: function (val) {
        this.loading = true;
        if (!val) return;
        this.imgODSSelected = this.getImg(val.file);
      },
      deep: true
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    changeTipoSelected ({ value }) {
      if (value === 'Cualitativo') {
        const refs = [this.$refs.refPeriodicidad, this.$refs.refMedida];
        refs.forEach(ref => ref.resetValidation());

        this.optionPeriodicidadSelected = null;
        this.unidadMedida = null;
        this.minimoRecomendado = null;
        this.recomendadoPor = null;
      }
    },
    disableSave () {
      let tipoValue = '';
      if (this.optionsTipoSelected && !this.optionsTipoSelected.value) {
        tipoValue = this.optionsTipoSelected;
      } else if (this.optionsTipoSelected && this.optionsTipoSelected.value) {
        tipoValue = this.optionsTipoSelected.value;
      }
      if (tipoValue === 'Cualitativo') {
        return (this.name === '' || (tipoValue === '' || tipoValue === undefined));
      } else {
        return (this.name === '' || this.name === undefined || this.name === null) ||
        (this.optionPeriodicidadSelected === '' || this.optionPeriodicidadSelected === undefined || this.optionPeriodicidadSelected === null) ||
        (this.unidadMedida === '' || this.unidadMedida === undefined || this.unidadMedida === null) ||
        (tipoValue === '' || tipoValue === undefined);
      }
    },
    disableInputsByTipo () {
      if (this.optionsTipoSelected) {
        if (!this.optionsTipoSelected.value) {
          if (this.optionsTipoSelected === 'Cualitativo') {
            return true;
          }
        }
        if (this.optionsTipoSelected.value === 'Cualitativo') {
          return true;
        }
      }
      return false;
    },
    save () {
      this.$refs.form.validate().then(success => {
        if (success) {
          let minimo = (this.minimoRecomendado === '') ? null : Number(this.minimoRecomendado);
          this.newDato = {
            idIndicador: this.datosIndicador.id,
            name: this.name,
            periodicidad: this.optionPeriodicidadSelected,
            unidadMedida: this.unidadMedida,
            tipo: this.optionsTipoSelected.value || this.optionsTipoSelected,
            minimoRecomendado: minimo,
            recomendadoPor: this.recomendadoPor,
            formula: this.formula,
            fuente: this.fuente,
            descripcion: this.descripcion,
            beneficio: this.beneficio,
            aclaraciones: this.aclaraciones,
            idODS: this.objetivoODSSelected.id,
            idObjetivoEstrategico: this.objetivoEstrategicoSelected.id,
            idObjetivoEspecifico: this.objetivoEspecificoSelected.id
          };
          this.$emit('input', false);
          this.$emit('saveDetalleIndicadorEdicionManual', this.newDato);
        }
      });
    },
    fillDetalle () {
      if (this.optionsTipo) {
        if (this.datosIndicador.tipo) {
          this.optionsTipoSelected = this.optionsTipo.filter((tipo) => {
            if (tipo.value === this.datosIndicador.tipo) {
              return tipo;
            }
          })[0].value;
        }
      }

      if (this.optionsPeriodicidad) {
        if (this.datosIndicador.periodicidad) {
          this.optionPeriodicidadSelected = this.optionsPeriodicidad.filter((periodo) => {
            if (periodo === this.datosIndicador.periodicidad) {
              return periodo;
            }
          })[0];
        }
      }

      this.name = this.datosIndicador.name;
      this.periodicidad = this.datosIndicador.periodicidad;
      this.unidadMedida = this.datosIndicador.unidadMedida;
      this.minimoRecomendado = this.datosIndicador.minimoRecomendado !== undefined ? this.datosIndicador.minimoRecomendado : this.datosIndicador.maximoRecomendado;
      this.labelRecomendado = 'Mínimo Recomendado';
      this.recomendadoPor = this.datosIndicador.recomendadoPor;
      this.fuente = this.datosIndicador.fuente;
      this.formula = this.datosIndicador.formula;
      this.descripcion = this.datosIndicador.descripcion;
      this.beneficio = this.datosIndicador.beneficio;
      this.aclaraciones = this.datosIndicador.aclaraciones;
      this.fillSelectorObjetivosEstategicos();
      this.fillSelectorObjetivosODS();

      if (this.optionsTipoSelected === 'Cualitativo') {
        const refs = [this.$refs.refPeriodicidad, this.$refs.refMedida];
        refs.forEach(ref => ref.resetValidation());

        this.optionPeriodicidadSelected = null;
        this.unidadMedida = null;
        this.minimoRecomendado = null;
        this.recomendadoPor = null;
      }
    },
    async fillSelectorObjetivosEstategicos () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_AUEOBJETIVES).then(response => {
        this.arrayObjetivosEstrategicos = [];
        this.arrayObjetivosEstrategicos.push({ name: 'Seleccione un objetivo estratégico', file: [{ fileKey: 'imagen', url: require(`@/assets/img/AUE.svg`) }] });
        let count = 0;
        response.data.forEach(objetivo => {
          let objetivoFormated = objetivo.prefix + ': ' + objetivo.name;
          this.arrayObjetivosEstrategicos.push({ name: objetivoFormated, file: objetivo.file, id: objetivo.id });
          if ((this.datosIndicador.objetivoEstrategico !== null && this.datosIndicador.objetivoEstrategico !== undefined) && this.datosIndicador.objetivoEstrategico.id === objetivo.id) {
            count++;
            this.objetivoEstrategicoSelected = { name: objetivoFormated, file: objetivo.file, id: objetivo.id };
          }
        });
        if (count === 0) {
          this.objetivoEstrategicoSelected = this.arrayObjetivosEstrategicos[0];
        }

        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    async fillSelectorObjetivosODS () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_ALL_ODSOBJETIVOS).then(response => {
        this.arrayObjetivosODS = [];
        this.arrayObjetivosODS.push({ name: 'Seleccione un objetivo de desarrollo sostenible', file: [{ fileKey: 'imagen', url: require(`@/assets/img/ods-logo-rueda.png`) }] });
        let count = 0;
        response.data.forEach(objetivo => {
          this.arrayObjetivosODS.push({ name: objetivo.name, file: objetivo.file, id: objetivo.id });
          if (this.datosIndicador.objetivoODS.id === objetivo.id) {
            count++;
            this.objetivoODSSelected = objetivo;
          }
        });
        if (count === 0) {
          this.objetivoODSSelected = this.arrayObjetivosODS[0];
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    async fillSelectorObjetivosEspecificos () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_OBJETIVOS_ESPECIFICOS, { idObjetivo: this.objetivoEstrategicoSelected.id }).then(response => {
        this.arrayObjetivosEspecificos = [];
        this.arrayObjetivosEspecificos.push({ name: 'Seleccione un objetivo específico' });
        let count = 0;
        response.data.forEach(objetivo => {
          this.arrayObjetivosEspecificos.push(objetivo);
          if (this.datosIndicador.objetivoEspecifico.id === objetivo.id) {
            count++;
            this.objetivoEspecificoSelected = objetivo;
          }
        });
        if (count === 0) {
          this.objetivoEspecificoSelected = this.arrayObjetivosEspecificos[0];
        }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    getImg (fileArray) {
      let res = this.searchResource(fileArray, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    }
  }
};
</script>

<style lang="scss" scoped>
.form-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  column-gap: 20px;
  margin-bottom: 6px;
  .input-name {
    width: 75%;
  }
  .input-tipo {
    width: 25%;
  }
  .input-20 {
    width: 20%;
  }
  .input-40 {
    width: 40%;
  }
  .input-35 {
    width: 35%;
  }
  .input-60 {
    width: 64%;
  }
  .input-100 {
    width: 100%;
  }
}
.form-row-bottom-space {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  column-gap: 20px;
  margin-bottom: 26px;
  .input-40 {
    width: 40%;
  }
  .input-60 {
    width: 64%;
  }
  .input-100 {
    width: 100%;
  }
}
.card-authorization {
  min-width: 1200px;
  .header {
    padding-top: 18px;
    #title-card-authorization {
      font-family: DINPro;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.29;
      color:#474848;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  .container-auth {
    .title-option {
      font-family: DINPro;
      font-size: 15px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #5c5c5c;
      padding-bottom: 20px;
    }
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
    .q-field--labeled .q-field__native {
      padding-bottom: 12px;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}

  .row {
    div{
      padding: 4px;
    }
  }
  .divLabel {
    font-family: DINPro;
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.27px;
    color: #002f6c;
    margin-bottom:5px;
  }
  .Imagen{
    float: left;
    margin-right: 12px;
    background-color: white;
  }

  .input {
    background-color: #fff;
    border-radius: 10px;
  }
  .select {
    padding-top: 15px;
  }
  .select:last-of-type {
    padding-top: 0px;
  }

</style>
